import { Component, OnInit, AfterViewInit, NgZone } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';

import * as _ from 'lodash';

import { Router } from '@angular/router';
import { HelperService } from './../../../../services/helper.service';
import { PaymentService } from './../../../../rest/api/payment.service';
import { DateValidator } from './../../../../validator/date-validator';
import { AuthService } from './../../../../services/auth.service';

declare var Multipayment: any;

import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-add-payment',
  templateUrl: './add-payment.component.html',
  styleUrls: ['./add-payment.component.scss']
})
export class AddPaymentComponent implements OnInit, AfterViewInit {

  paymentForm: FormGroup;
  expiryDate: FormGroup;

  paymentSuccessMessage: any;
  paymentErrorMessage: any;

  errors = [];
  isSubmitted = false;
  isSubmitting = false;

  accessToken: any;
  isLoading: any;
  card = '';
  name = '';
  expDate = '';
  // tslint:disable-next-line:max-line-length
  // cCardNoRegex = '^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$';
  cCardNoRegex: any;
  mastCardRegex = '^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$';
  // mastCardRegex = '^%B(5[1-5][0-9]{14})\\^([A-Z ]+)/([A-Z ]+)(\\.[A-Z ]+)?\\^([0-9]{2})([0-9]{2})';
  visaCardRegex = '^4[0-9]{15}(?:[0-9]{3})?$';
  visaCardRegex1 = '^4[0-9]{14}(?:[0-9]{3})?$';

  discoverCardRegex = '^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)';
  jcbCardRegex = '^35(2[89]|[3-8][0-9])';
  amexCardRegex = '^3[47][0-9]{13}$';
  dinersCardRegex = '^3(?:0[0-5]|[68][0-9])[0-9]{11}$';
  cardHolderName = '^[a-zA-Z\s ]+$';
  expiryDateRegex = '^(0[7-9]|1[0-2])/(1[8-9])|(0[1-9]|1[0-2])/(2[0-9]|3[0-9])$';
  ccvCodeRegex = '^[0-9]{3,4}$';
  cardActiveClass: any;
  paymentData = {};

  paymentToken: any;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    public paymentService: PaymentService,
    public helperService: HelperService,
    private authService: AuthService,
    public ngZone: NgZone
  ) {
    this.cCardNoRegex = this.visaCardRegex + '|' + this.visaCardRegex1 + '|' + this.discoverCardRegex + '|' + this.jcbCardRegex + '|' + this.amexCardRegex + '|' + this.dinersCardRegex + '|' + this.mastCardRegex;
    this.initializeForm();
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    // SDK Payment initialiation
    setTimeout(() => {
      Multipayment.init (environment.paymentApiKey);
    }, 1000);
  }

  initializeForm() {

    this.expiryDate = this.fb.group({
      month: new FormControl('', [Validators.required]),
      year: new FormControl('', [Validators.required])
    });

    this.paymentForm = this.fb.group({
      cardNumber: ['', [Validators.required, Validators.pattern(this.cCardNoRegex)] ],
      ccvCode: ['', [Validators.required, Validators.pattern(this.ccvCodeRegex)] ],
      expiryDate: this.expiryDate,
      nameOnCard: ['', [Validators.required, , Validators.pattern(this.cardHolderName)] ]
    }, {
      validator: [DateValidator.ExpiryDate]
    });
  }

  submitForm(value) {
    if (!this.paymentForm.valid) {
      this.isSubmitted = true;
      return;
    }

    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;

    const formData = _.cloneDeep(value);

    const cardObject = {
      cardno: formData.cardNumber,
      expire: formData.expiryDate.year + formData.expiryDate.month,
      securitycode: formData.ccvCode,
      holdername: formData.nameOnCard,
    };
    Multipayment.getToken (cardObject, (response) => this.ngZone.run(() => {
      if (response.resultCode !== '000') {
        // show error message
        this.isSubmitted = false;
        this.isSubmitting = false;
        this.paymentErrorMessage = 'There was error while processing your card information';
      } else {
        // use this token instead of card details to create transactions
        this.paymentToken = response.tokenObject.token;
        this.changeCreditCardApi();
      }
    }));
  }

  changeCreditCardApi() {
    let data;

    data = {
      registerToken: this.paymentToken,
    };
    data = this.helperService.updateJsonFormat(data);
    this.paymentService.changeCreditCard({
      Authorization: this.accessToken,
      body: data
    }).subscribe((response: any) => {
      this.paymentSuccessMessage = 'Your card was sucessfully changed.';
      this.resetForm();
      setTimeout(() => {
        this.router.navigate(['/member/settings/account/billing']);
      }, 2000);
    }, err => {
      if (err && err.error && err.error.errors && err.error.errors[0]) {
        this.errors = err.error.errors;
        setTimeout(() => {
          this.resetErrorValues();
        }, 5000);
      } else {
        this.paymentErrorMessage = 'There was error while changing your card information.';
        setTimeout(() => {
          this.resetErrorValues();
        }, 5000);
      }
      this.isSubmitted = false;
      this.isSubmitting = false;
    });
  }

  getExpiryMonth() {
    const workingHour = this.paymentForm.get('expiryDate').get('month') as FormGroup;
    return workingHour;
  }

  getExpiryYear() {
    const workingHour = this.paymentForm.get('expiryDate').get('year') as FormGroup;
    return workingHour;
  }

  resetForm() {
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.resetFormValues();
  }

  resetFormValues() {
    this.paymentForm.reset();
  }

  resetErrorValues() {
    this.paymentErrorMessage = undefined;
    this.errors = [];
  }

  resetSuccessValues() {
    this.paymentSuccessMessage = undefined;
  }

}
